import { render, staticRenderFns } from "./DevelopOverView.vue?vue&type=template&id=2ad0fb4d&scoped=true"
import script from "./DevelopOverView.vue?vue&type=script&lang=js"
export * from "./DevelopOverView.vue?vue&type=script&lang=js"
import style0 from "./DevelopOverView.vue?vue&type=style&index=0&id=2ad0fb4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad0fb4d",
  null
  
)

export default component.exports